'use client'
import { Button } from '@chakra-ui/react'
import React, { useState, useEffect } from 'react'
import { UpIcon } from '@/_assets/icon-components'

function UpBtn() {
  const [moreScrollDown, setMoreScrollDown] = useState(false)

  useEffect(() => {
    const handleScrollDown = () => {
      const scrollPosition =
        window.scrollY || document.documentElement.scrollTop
      setMoreScrollDown(scrollPosition > 800)
    }

    window.addEventListener('scroll', handleScrollDown)
    return () => {
      window.removeEventListener('scroll', handleScrollDown)
    }
  }, [])

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }

  return (
    <Button
      p={3}
      w='48px'
      h='48px'
      right='20px'
      zIndex={1000}
      boxShadow='md'
      cursor='pointer'
      position='fixed'
      borderRadius='full'
      bgColor='primary'
      color='primary.text'
      _hover={{
        bg: 'primary.hover',
      }}
      onClick={scrollToTop}
      bottom={{ base: 24, md: 8 }}
      style={{
        opacity: moreScrollDown ? 1 : 0,
        visibility: moreScrollDown ? 'visible' : 'hidden',
        transform: moreScrollDown ? 'translateY(0)' : 'translateY(20px)',
        transition:
          'opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease',
      }}
    >
      <UpIcon />
    </Button>
  )
}

export default UpBtn
